import { api } from '@/lib/api';

export const invoicesService = {
  async getAll() {
    const { data } = await api.get('/invoices');
    return { data };
  },

  async create(body) {
    const { data } = await api.post('/invoices', body);
    return { data };
  },

  async update(id, body) {
    const { data } = await api.patch(`/invoices/${id}`, body);
    return { data };
  },

  async delete(id) {
    await api.delete(`/invoices/${id}`);
    return { success: true };
  },
};
